<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xtwcsO/tc-custom/9781623957964.jpg?1726574077010" alt="This image is the cover for the book Dream Dragon, Xist Children's Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dream Dragon, Xist Children's Books
      </h1>
      <p class="bookDescription body article font2">
        <p>A dragon protects a child’s dreams from nightmares in this picture book perfect for bedtime.  Bedtime stories inspires a series of dream protectors for a little boy. The dream dragon keeps the nightmares away and is joined by dinosaurs, pirates, super heroes and more in the quest to keep nighttime safe.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kathyrn England, Valeria Issa
      </h2>
      
      <p class="authorDescription body article">Kathryn is an Australian author who likes reading children's books as much as she likes writing them. She has written lots of children's books including picture books, chapter books and novels. Some of her ideas come from her imagination while others are based on events in her life.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Xist Publishing 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b18e573